import React from "react";
import { IonContent } from "@ionic/react";
import PermitDetails from "./PermitDetails";
import PermitDetailsAffectedServices from "./PermitDetailsAffectedServices";
import { Permit } from "../models/Permit";
import PermitAssignmentsContainer from "../containers/PermitAssignmentsContainer";
import { PermitAssignment } from "../models/PermitAssignment";
import { PermitAuthorisationSignature } from "../models/PermitAuthorisationSignature";

interface Props {
    permit: Permit;
    permitSubmitterName: string;
    onPermitAssignmentSignatureSubmitted: (signature: PermitAuthorisationSignature, signatureDataUrl: string) => void;
    onPermitAssigneeUpdated: (assignment: PermitAssignment) => void;
    isReadOnly: boolean;
}

const PermitDetailsTab: React.FC<Props> = ({
    permit,
    permitSubmitterName,
    onPermitAssignmentSignatureSubmitted,
    onPermitAssigneeUpdated,
    isReadOnly,
}) => {
    return (
        <IonContent>
            <PermitDetails
                locationOfWork={permit.locationOfWork}
                validFrom={permit.validFrom}
                validTo={permit.validTo}
                comments={permit.comments}
                emergencyContact={permit.emergencyContact}
                submittedBy={permitSubmitterName}
                dateSubmitted={permit.dateSubmitted}
                workDescription={permit.worksDescription}
                maxPenetrationDepth={permit.maxPenetrationDepth}
                permittedEquipment={permit.permittedEquipment}
                subContractor={permit.subContractor}
                project={permit.project}
                calibrationCertificate={permit.calibrationCertificate}
                template={permit.template}
                fieldValues={permit.fieldValues}
            />
            {(permit.template?.features.affectedServices.enabled ?? true) && (
                <PermitDetailsAffectedServices affectedServices={permit.affectedServices} />
            )}
            <PermitAssignmentsContainer
                permit={permit}
                isReadOnly={isReadOnly}
                onPermitAssignmentSignatureSubmitted={onPermitAssignmentSignatureSubmitted}
                onPermitAssigneeUpdated={onPermitAssigneeUpdated}
            />
        </IonContent>
    );
};

export default PermitDetailsTab;
